// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-3-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.5 5H15.5V6.5L10.5 10V11H12C14.2091 11 16 12.7909 16 15C16 17.2091 14.2091 19 12 19H11.5C9.29086 19 7.5 17.2091 7.5 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers31Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-3-1',
    ref,
    icon: element,
  },
));

Numbers31Icon.displayName = 'Numbers31Icon';

export default Numbers31Icon;
